import { Routes, Route } from 'react-router-dom';
import { Form } from 'antd';
import ProcessingTime from './ProcessingTime';
import ApplicationLayout from '../Layout';
import Feedback from '../components/Feedback';
import DaysOff from './DaysOff';
import Error from './Error';

const coverStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  margin: 'initial',
};

export default function ODGApplication() {
  const [form] = Form.useForm();
  return (
    <ApplicationLayout type="odg" coverStyle={coverStyle}>
      <Form
        name="enable_bp"
        layout="vertical"
        form={form}
        initialValues={{
          timeZone: 'America/New_York',
        }}
      >

        <Routes>
          <Route
            path="/processing-time"
            element={<ProcessingTime />}
          />
          <Route path="/days-off" element={<DaysOff />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/error" element={<Error />} />
        </Routes>
      </Form>
    </ApplicationLayout>

  );
}
